// extracted by mini-css-extract-plugin
module.exports = {"inputs":"ReasonAndCommentInputs_inputs__1fz3z","inputs__reason":"ReasonAndCommentInputs_inputs__reason__IGmbw","inputs__comment":"ReasonAndCommentInputs_inputs__comment__2ss0A"};